export const MENU_DIRECTION_LEFT = 'left';
export const MENU_DIRECTION_RIGHT = 'right';

export const resolveMenuDirection = ({
  triggerLeft, triggerRight, menuWidth, viewportWidth,
}) => {
  if (triggerRight - menuWidth >= 0) return MENU_DIRECTION_LEFT;
  if (triggerLeft + menuWidth <= viewportWidth) return MENU_DIRECTION_RIGHT;

  return triggerRight >= viewportWidth - triggerLeft
    ? MENU_DIRECTION_LEFT
    : MENU_DIRECTION_RIGHT;
};
